/* eslint-disable prettier/prettier */
/* eslint-disable */

import genericReducers from '../genericReducer';
import { connectReducers } from '../../utils';
import { IReducers } from '../index';

import { GET_INTEREST_HEAD_KINDS } from '../../actions';
import { REQUEST, FAILURE, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IInterestHeadKind } from '../../api/types';

export type InterestHeadKindsState = ICommonResponse<IInterestHeadKind>;

const initialState = {
  content: [],
  loading: false,
} as InterestHeadKindsState;
const generic = genericReducers<InterestHeadKindsState>();
const interestHeadKinds: IReducers<InterestHeadKindsState> = {
  [GET_INTEREST_HEAD_KINDS[REQUEST]]: generic.get.request,
  [GET_INTEREST_HEAD_KINDS[SUCCESS]]: generic.get.success,
  [GET_INTEREST_HEAD_KINDS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, interestHeadKinds);
